import React, { useMemo, useState } from "react";
import { EmailComposer } from "../../screen/emailMarketing/EmailComposer";
import {
  DEFAULT_EMAIL_HTML,
  isEmptyEmailHtml,
  resolvePlatformTemplateInitialMode,
} from "../../screen/emailMarketing/emailHtmlUtils";
import "../../screen/emailMarketing/EmailMarketing.scss";
import PlatformVariableChips from "./PlatformVariableChips";

type Props = {
  open: boolean;
  templateId?: number | string;
  name: string;
  subject: string;
  html: string;
  saving?: boolean;
  onNameChange: (value: string) => void;
  onSubjectChange: (value: string) => void;
  onHtmlChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  onPublish?: () => void;
};

export default function PlatformTemplateComposer({
  open,
  templateId,
  name,
  subject,
  html,
  saving = false,
  onSubjectChange,
  onHtmlChange,
  onClose,
  onSave,
  onPublish,
}: Props) {
  const [subjectInput, setSubjectInput] = useState<HTMLInputElement | null>(
    null
  );

  const bodyHtml = isEmptyEmailHtml(html) ? DEFAULT_EMAIL_HTML : html;
  const initialMode = useMemo(
    () => resolvePlatformTemplateInitialMode(bodyHtml),
    [bodyHtml]
  );
  const composerKey = `${templateId ?? "new"}-${initialMode}`;

  const insertVariable = (token: string) => {
    const input = document.querySelector(
      ".email-mkt__composer-subject-row input"
    ) as HTMLInputElement | null;
    if (!input) {
      onSubjectChange(`${subject}${token}`);
      return;
    }
    const start = input.selectionStart ?? subject.length;
    const end = input.selectionEnd ?? subject.length;
    const next = `${subject.slice(0, start)}${token}${subject.slice(end)}`;
    onSubjectChange(next);
    setSubjectInput(input);
    requestAnimationFrame(() => {
      const el = subjectInput || input;
      el.focus();
      const pos = start + token.length;
      el.setSelectionRange(pos, pos);
    });
  };

  if (!open) return null;

  return (
    <>
      <EmailComposer
        key={composerKey}
        open={open}
        subject={subject}
        html={bodyHtml}
        initialMode={initialMode}
        saving={saving}
        onSubjectChange={onSubjectChange}
        onHtmlChange={onHtmlChange}
        onClose={onClose}
        onSaveDraft={onSave}
        onPublish={onPublish}
        saveLabelId="app.platformAutomations.template.saveDraft"
      />
      <div className="pa-template-composer-vars">
        <PlatformVariableChips onInsert={insertVariable} />
      </div>
    </>
  );
}
